module.exports = __webpack_public_path__ + "img/login_left1.90268a7e.jpg";